import logo from "../assets/logos/evue-logo.png";

const Logo = () => {
  return <img src={logo} alt="eVue" width="100" />;
};

export default Logo;
